import React, { useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../Buttons'
import BPSelect from './BPSelect'
import { t } from 'i18next'
import styled from 'styled-components'
const StyledWrapper = styled.div`
  margin-bottom: 30px;
 
`
const BPSelectModal = ({ selectedBPs, setSelectedBPs, handleSave, hideBPs, handleSaveIsLoading, setShowAddBPsModal, singleSelection}) => {
  const listRef = useRef(null)
  const handleClose = () => {
    setShowAddBPsModal(false)
  }
  return (
    <Modal size="lg" centered show={true} onHide={handleClose} scrollable>
      <Modal.Header closeButton className="pb-0">
        <Modal.Title>
          <div>
            <p className="m-0 pt-2">{t('searchBP:selectBP')}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body ref={listRef}>
        <StyledWrapper>
          <BPSelect selectedBPs={selectedBPs} setSelectedBPs={setSelectedBPs} hideBPs={hideBPs} listRef={listRef} singleSelection={singleSelection}/>
        </StyledWrapper>
      </Modal.Body>
      <Modal.Footer>
        <ButtonWithLoadingState
          variant='primary'
          buttonText={`${t('saveButton')} ${selectedBPs.length ? `(${selectedBPs.length})` : ''}`}
          isLoading={handleSaveIsLoading}
          onClick={handleSave}
        />
      </Modal.Footer>
    </Modal >
  )
}

export default BPSelectModal